import React from 'react';
import { createTableElementClassName } from './tableStyles';

export const TableHead: React.FC = (props) => {
  const { children } = props;

  const className = createTableElementClassName('head');

  return <thead className={className}>{children}</thead>;
};
